var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showButton
    ? _c("div", { staticClass: "row mb-0 mb-md-5 mt-4" }, [
        _vm.display("custom_checkboxes")
          ? _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "mb-3" },
                _vm._l(_vm.custom_checkboxes, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "form-check text-start" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.customCheckboxesCheck[index],
                            expression: "customCheckboxesCheck[index]",
                          },
                        ],
                        staticClass: "form-check-input",
                        class: {
                          "is-invalid":
                            "custom_checkboxes" in _vm.errors &&
                            !_vm.customCheckboxesCheck[index],
                        },
                        attrs: {
                          type: "checkbox",
                          value: "",
                          id: `customCheck${index}`,
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.customCheckboxesCheck[index]
                          )
                            ? _vm._i(_vm.customCheckboxesCheck[index], "") > -1
                            : _vm.customCheckboxesCheck[index],
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.customCheckboxesCheck[index],
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.customCheckboxesCheck,
                                    index,
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.customCheckboxesCheck,
                                    index,
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.customCheckboxesCheck, index, $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", {
                        staticClass: "form-check-label small",
                        attrs: { for: `customCheck${index}` },
                        domProps: {
                          innerHTML: _vm._s(_vm.snarkdown(item.text)),
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.display("marketing_checkbox")
          ? _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "mb-3" }, [
                _c("div", { staticClass: "form-check text-start" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.marketing,
                        expression: "marketing",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      value: "",
                      id: "marketing-checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.marketing)
                        ? _vm._i(_vm.marketing, "") > -1
                        : _vm.marketing,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.marketing,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.marketing = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.marketing = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.marketing = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", {
                    staticClass: "form-check-label small",
                    attrs: { for: "marketing-checkbox" },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.snarkdown(_vm.marketing_checkbox_text)
                      ),
                    },
                  }),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.display("display_no_return_policy_info")
          ? _c("div", { staticClass: "col-12 text-muted mb-2" }, [
              _c("small", [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm._f("translate")(
                        "By clicking the button below to proceed you agree that you will be provided with immediate access to digital content as soon as you complete your purchase, without waiting the 14-day withdrawal period. Therefore, you expressly waive your right to withdraw from this purchase."
                      )
                    ) +
                    "\n    "
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "text-muted" }, [
            _vm.display("standard_agreement")
              ? _c(
                  "div",
                  {
                    staticClass: "mb-3 small",
                    attrs: { id: "standard_agreement" },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("translate")(
                              "By completing this purchase, I agree to"
                            )
                          ) +
                          "\n          "
                      ),
                      _c("a", { attrs: { href: "/terms", target: "_blank" } }, [
                        _vm._v(_vm._s(_vm._f("translate")("Terms"))),
                      ]),
                      _vm._v(
                        "\n\n          " +
                          _vm._s(_vm._f("translate")("and")) +
                          "\n          "
                      ),
                      _c(
                        "a",
                        { attrs: { href: "/privacy", target: "_blank" } },
                        [
                          _vm._v(
                            _vm._s(_vm._f("translate")("Privacy Policy")) + "."
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.display_additional_legal_notes
              ? _c("div", {
                  staticClass: "mb-3 small",
                  attrs: { id: "additional_legal_notes" },
                  domProps: { innerHTML: _vm._s(_vm.additional_legal_notes) },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-grid" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-dark p-2 hover-shadow p-0 overflow-hidden",
                staticStyle: { "font-weight": "600" },
                attrs: { id: "buy-btn", disabled: _vm.working },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  },
                },
              },
              [
                _c("div", { staticClass: "shine" }),
                _vm._v(" "),
                _c("div", { staticClass: "float-end" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "css-i6dzq1",
                      attrs: {
                        viewBox: "0 0 24 24",
                        width: "20",
                        height: "20",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        fill: "none",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "3",
                          y: "11",
                          width: "18",
                          height: "11",
                          rx: "2",
                          ry: "2",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "M7 11V7a5 5 0 0 1 10 0v4" } }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.working
                  ? _c("span", {
                      staticClass: "spinner-border spinner-border-sm",
                      attrs: { role: "status", "aria-hidden": "true" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAccess
                  ? _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("translate")("Get access")) +
                          "\n        "
                      ),
                    ])
                  : _vm.isFree
                  ? _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("translate")("Get free access")) +
                          "\n        "
                      ),
                    ])
                  : _vm.checkoutType === "single"
                  ? _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("translate")("Confirm and pay")) +
                          "\n        "
                      ),
                    ])
                  : _vm.checkoutType === "membership"
                  ? _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("translate")("Subscribe")) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "toast-container position-fixed bottom-0 end-0 p-3",
              },
              [
                !_vm.isEmpty(_vm.errors)
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "toast align-items-center text-bg-warning border-0",
                        attrs: {
                          role: "alert",
                          "aria-live": "assertive",
                          "aria-atomic": "true",
                        },
                      },
                      [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("div", { staticClass: "toast-body px-3" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("translate")("Validation error")
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("button", {
                            staticClass: "btn-close btn-close-dark me-3 m-auto",
                            attrs: {
                              type: "button",
                              "data-bs-dismiss": "toast",
                              "aria-label": "Close",
                            },
                          }),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.paymentProviderLogoSrc && !_vm.isFree
            ? _c("div", { staticClass: "mt-3 small text-secondary" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-center align-items-center",
                  },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm._f("translate")(
                            "Transaction security is ensured by"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "img-fluid ms-3",
                      staticStyle: { "max-height": "22px" },
                      attrs: {
                        src: _vm.paymentProviderLogoSrc,
                        alt: _vm.paymentProvider,
                      },
                    }),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm.enrollment_disabled
    ? _c("div", { staticClass: "d-grid" }, [
        _c(
          "button",
          { staticClass: "btn btn-primary", attrs: { disabled: "" } },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm._f("translate")("Enrollment disabled")) +
                "\n  "
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }